var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item",class:{active: _vm.active}},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.item.Name))]),_c('div',{staticClass:"logo"})])
}
var staticRenderFns = []

export { render, staticRenderFns }